const routes = {
	path: '/cleaner',
	component: resolve => require ( ['./../cleaner-views/index.vue'], resolve ),
	children: [
		{
			path: 'dashboard',
			alias: '',
			component: resolve => require ( ['./../cleaner-views/cleaners-dashboard.vue'], resolve ),
			meta: {
				breadcrumb: 'Dashboard'
			}
		},
		{
			path: 'upcoming',
			alias: '',
			component: resolve => require ( ['./../cleaner-views/upcoming-list.vue'], resolve ),
			meta: {
				breadcrumb: 'Upcoming Jobs'
			}
		},
		{
			path: 'past',
			component: resolve => require ( ['./../cleaner-views/past-list.vue'], resolve ),
			meta: {
				breadcrumb: 'Past Jobs'
			}
		},
		{
			path: 'upcoming/:jobID',
			component: resolve => require ( ['./../cleaner-views/job-details.vue'], resolve )
		},
		{
			path: 'past/:jobID',
			component: resolve => require ( ['./../cleaner-views/job-details.vue'], resolve )
		},
		{
			path: 'profile',
			alias: '',
			component: resolve => require ( ['./../cleaner-views/cleaner-form.vue'], resolve ),
			meta: {
				breadcrumb: 'Update Profile'
			}
		},
		{
			path: 'jobs/:jobID',
			component: resolve => require ( ['./../cleaner-views/job-details.vue'], resolve )
		},
	]
};

export default routes;


// WEBPACK FOOTER //
// ./src/custom/routes/cleaner-routes.js